<template>
  
<!-- Google tag (gtag.js) -->
<script async src="https://www.googletagmanager.com/gtag/js?id=AW-974148699"></script>
<script>
  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());

  gtag('config', 'AW-974148699');
</script>

  <link rel="preconnect" href="https://fonts.googleapis.com">
<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
<link href="https://fonts.googleapis.com/css2?family=Great+Vibes&display=swap" rel="stylesheet">
  <div :class="{'header': true, 'scrolled': !isAtTop}">

    <div class="titleblock">
      <img src="@/assets/logo/DMLogo_Transp_optimized_.png" class="logo">
      <p class="title" @click="scrollToSection('home')">Darling Moments Photography</p>
    </div>
    <div class="menublock">
      <!-- Hamburger Menu -->
      <input type="checkbox" id="menuToggle" class="menuToggle" ref="menuToggle"/>
      <label for="menuToggle" class="hamburger">
        <span></span>
        <span></span>
        <span></span>
      </label>

      <!-- Menu Items -->
      <div class="menuItems">
        <p class="menuItem" @click="scrollToSection('home')">Home</p>
        <p class="menuItem" @click="scrollToSection('portfolio')">Portfolio</p>
        <p class="menuItem" @click="scrollToSection('about')">About</p>
        <p class="menuItem" @click="scrollToSection('contact')"><span class="cont">Contact</span></p>
      </div>
    </div>  
  </div>
  <div class="main" ref="home">
    <div class="banner">
      <img src="@/assets/banner.jpg" class="bannerIMG" alt="Photographer Brianna of Darling Moments Photography in Moline, IL">>
      <div class="headerStuff">
        <h1>Hello,</h1>
        <h3>I'm Brianna!</h3>
        <button class="CTA" @click="scrollToSection('contact')">Contact Me</button>
      </div>
    </div>
    <div class="scrolling-gallery" ref="gallery">
      <div
        class="gallery-track"
        ref="track"
        :style="galleryStyle"
        @mouseenter="isHovered = true"
        @mouseleave="isHovered = false"
        @wheel="handleWheel"
        @touchstart="handleTouchStart"
        @touchmove="handleTouchMove"
        @touchend="handleTouchEnd"
      >
        <img v-for="(image, index) in images" :key="index" :src="image" class="gallery-image" />
      </div>
    </div>



    <div class="Portfolio" ref="portfolio">
      <h2 class="work">My Work</h2>
      <div class="columns">
        <div class="column">
          <img src="@/assets/img1_optimized_.jpg" class="photo" alt="Photographer Brianna of Darling Moments Photography in Moline, IL">>
          <img src="@/assets/img160_optimized_.jpg" class="photo" alt="Photographer Brianna of Darling Moments Photography in Moline, IL">>
          <img src="@/assets/img131_optimized_.jpg" class="photo" alt="Photographer Brianna of Darling Moments Photography in Moline, IL">>
        </div>
        <div class="column">
          <img src="@/assets/img8_optimized_.jpg" class="photo" alt="Photographer Brianna of Darling Moments Photography in Moline, IL">>
          <img src="@/assets/img155_optimized_.jpg" class="photo" alt="Photographer Brianna of Darling Moments Photography in Moline, IL">>
          <img src="@/assets/img129.jpg" class="photo" alt="Photographer Brianna of Darling Moments Photography in Moline, IL">>
          <img src="@/assets/img148.jpg" class="photo" alt="Photographer Brianna of Darling Moments Photography in Moline, IL">>
        </div>
        <div class="column">
          <img src="@/assets/img125_optimized_.jpg" class="photo" alt="Photographer Brianna of Darling Moments Photography in Moline, IL">>
          <img src="@/assets/img150_optimized_.jpg" class="photo" alt="Photographer Brianna of Darling Moments Photography in Moline, IL">>
          
          <img src="@/assets/img12_optimized_.jpg" class="photo" alt="Photographer Brianna of Darling Moments Photography in Moline, IL">>
          <img src="@/assets/img11_optimized_.jpg" class="photo" alt="Photographer Brianna of Darling Moments Photography in Moline, IL">>
        </div>
      </div>
    </div>
    <div class="spacer" ref="about"></div>
    <div class="About" >
      <div class="aboutText">
        <h2 class="work">About Me</h2>
        <p>Hi!</p>
        <p>My name is Brianna, and I'm the face behind Darling Moments Photography. I have a passion for helping others save and cherish life’s most precious moments — whether it's the quiet joy of a newborn session or the laughter of a family gathering. As seasons come and go, I find it deeply important to capture those special times so you can hold onto them for a lifetime.</p>
        <p>I specialize in natural light photography with a focus on family and individual portraits, pets, couples sessions, and weddings. My goal is to make every session feel relaxed, fun, and authentic — capturing real smiles, little details, and meaningful connections.</p>
        <p>With several years of experience in both veterinary medicine and early childhood education, I bring a calm, confident presence to every session — whether I'm working with energetic toddlers, curious pets, or both! This background has given me the tools to create a safe, comfortable space where everyone — two-legged or four — can shine naturally in front of the camera.</p>
        <div class="packages">
          <div class="package">
            <h4>Mini Session – $150</h4>
            <li>20 minutes</li>
            <li>10 edited digital images</li>
            <li>Great for quick updates or seasonal shoots</li>
          </div>
          <div class="package">
            <h4>Standard Session – $275</h4>
            <li>45–60 minutes</li>
            <li>20+ edited digital images</li>
            <li>Ideal for families, individuals, or couples</li>
          </div>
          <!-- <div class="package">
            <h4>Newborn Session – $350</h4>
            <li>1.5–2 hours (in-home or studio style)</li>
            <li>20+ edited digital images</li>
            <li>Includes swaddling, props, and gentle posing</li>
          </div> -->
          <div class="package">
            <h4>Wedding Package – $1000</h4>
            <li>6-8 hours</li>
            <li>60+ edited digital images</li>
            <li>Includes full wedding day and portraits</li>
          </div>
          <div class="package">
            <h4>Pet Portraits - $200 & Pet End-of-Life – $100</h4>
            <li>30–45 minutes</li>
            <li>Gentle, flexible pacing to accommodate your pet’s energy</li>
            <li>Ideal for senior pets or commemorative portraits</li>
          </div>
        </div>
      </div>
      <img src="@/assets/bri3.jpg" class="aboutPhoto">
    </div>
    <title>Best Photography in Moline & Davenport | Darling Moments Photography</title>
      <meta name="description" content="Professional Photography in the Quad Cities. Serving Moline, IL & Davenport, IA.">
    <h2>Serving the Quad Cities: Moline & Davenport</h2>
    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d143220.45990702757!2d-90.72365840718929!3d41.52310415277644!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x87e234c5e012a2f1%3A0xe8ea1f6356581fb0!2sDavenport%2C%20IA!5e0!3m2!1sen!2sus!4v1751670936000!5m2!1sen!2sus" width="100%" height="400" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
    <div class="spacer" ref="contact"></div>
    <div class="Contact" >
      <h2 class="work">Contact Me</h2>
      <form name="contact" method="POST" netlify data-netlify="true" action="/thank-you">
  <!-- REQUIRED for Netlify to detect this form -->
  <input type="hidden" name="form-name" value="contact" />
  
  <!-- Optional subject -->
  <input type="hidden" name="subject" value="Sales inquiry from mysitename.netlify.app" />

  <p>
    <label>Your Name: <input type="text" name="name" required /></label>
  </p>
  <p>
    <label>Your Email: <input type="email" name="email" required /></label>
  </p>
  <p>
    <label>Message: <textarea name="message" required></textarea></label>
  </p>
  <p>
    <button type="submit">Send</button>
  </p>
</form>

      <p class="contactSub">Or contact me at:</p>
      <div class="contactInfo">
       <h4 class="email">darlingmomentsphotos@gmail.com</h4>
        <a href="https://www.facebook.com/profile.php?id=61550891451441"><h4>Darling Moments Photography on Facebook</h4> </a>
      </div>
      
      <img src="@/assets/img114.jpg" class="contactPhoto" alt="Photographer Brianna of Darling Moments Photography in Moline, IL">>
    </div>
  </div>
  <router-view />
</template>

<script>

export default {
    name:"HomePage",
  data() {
    return {
        formData: {
      email: '',
      message: '',
    },
      isAtTop: true,
      images: [
        require('@/assets/img111_optimized_.png'),
        require('@/assets/img158_optimized_.jpg'),
        require('@/assets/img130_optimized_.jpg'),
        require('@/assets/img121_optimized_.jpg'),
        require('@/assets/img153_optimized_.jpg'),
        require('@/assets/img154_optimized_.jpg'),
        require('@/assets/img123_optimized_.jpg'),
        require('@/assets/img157_optimized_.jpg'),
        require('@/assets/img113_optimized_.jpg'),
        require('@/assets/img143_optimized_.jpg'),
        require('@/assets/img164_optimized_.jpg'),
        require('@/assets/img128_optimized_.jpg'),
        require('@/assets/img149_optimized_.jpg'),
        require('@/assets/img144_optimized_.jpg'),
        require('@/assets/img132_optimized_.jpg'),
        require('@/assets/img119_optimized_.jpg'),
        require('@/assets/img147_optimized_.jpg'),
        require('@/assets/img122_optimized_.jpg'),
        require('@/assets/img135_optimized_.jpg'),
        //require('@/assets/img148.jpg'),
        require('@/assets/img115_optimized_.jpg'),
        require('@/assets/img151_optimized_.jpg'),
        require('@/assets/img163_optimized_.jpg'),
        require('@/assets/img152_optimized_.jpg'),
        require('@/assets/img136_optimized_.jpg'),
        require('@/assets/img117_optimized_.jpg'),
        require('@/assets/img112_optimized_.png'),
        require('@/assets/img159_optimized_.jpg'),
        require('@/assets/img116_optimized_.jpg'),
        require('@/assets/img140_optimized_.jpg'),
        require('@/assets/img134_optimized_.jpg'),
        require('@/assets/img120_optimized_.jpg'),
        require('@/assets/img167_optimized_.jpg'),
        require('@/assets/img118_optimized_.jpg'),
        require('@/assets/img139_optimized_.jpg'),
       // require('@/assets/img129.jpg'),
        require('@/assets/img145_optimized_.jpg'),
        require('@/assets/img124_optimized_.jpg'),
        require('@/assets/img162_optimized_.jpg'),
        require('@/assets/img141_optimized_.jpg'),
        require('@/assets/img126_optimized_.jpg'),
        require('@/assets/img142_optimized_.jpg'),
        require('@/assets/img137_optimized_.jpg'),
        require('@/assets/img127_optimized_.jpg'),
        require('@/assets/img156_optimized_.png'),
        require('@/assets/img146_optimized_.jpg'),
        require('@/assets/img133_optimized_.jpg'),
        require('@/assets/img165_optimized_.jpg'),
        
      ],
      scrollX: 0,
      isHovered: false,
      scrollSpeed: 1, // Controls auto-scroll speed
      autoScrollInterval: null,
      touchStartX: 0,
      isTouching: false,
    };
  },
  computed: {
    galleryStyle() {
      return {
        transform: `translateX(${this.scrollX}px)`,
      };
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("scroll", this.handleParallax);
    this.duplicateImages();
    this.startAutoScroll();
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("scroll", this.handleParallax);
    clearInterval(this.autoScrollInterval);
  },
  methods: {
    async handleSubmit() {
        const form = new FormData();
        form.append('form-name', 'contact');
        form.append('email', this.formData.email);
        form.append('message', this.formData.message);

        try {
        await fetch('/', {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: new URLSearchParams(form).toString(),
        });

        this.$router.push('/thank-you');
        } catch (err) {
        console.error(err);
        alert('There was an error. Please try again.');
        }
    },
    scrollToSection(section) {
      // Uncheck the checkbox
      this.$refs.menuToggle.checked = false;

      // Scroll to the section
      if (section === 'home') {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      } else {
        const element = this.$refs[section];
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }
    },
    handleScroll() {
      this.isAtTop = window.scrollY === 0;
    },
    handleParallax() {
    const scrollY = window.scrollY;
    const bannerImg = document.querySelector(".bannerIMG");
    const headerStuff = document.querySelector(".headerStuff");

    if (bannerImg) {
      bannerImg.style.transform = `translate(-50%, ${scrollY * 0.4}px)`; // Stronger effect for the image
    }
    
    if (headerStuff) {
      headerStuff.style.transform = `translate(-50%, calc(-50% + ${scrollY * 0.3}px))`; // Subtler effect for text
    }
  },
  duplicateImages() {
      this.images = [...this.images, ...this.images]; // Duplicate for infinite loop
    },
    startAutoScroll() {
      this.autoScrollInterval = setInterval(() => {
        if (!this.isHovered && !this.isTouching) {
          this.scrollX -= this.scrollSpeed;
          this.resetScrollIfNeeded();
        }
      }, 20);
    },
    resetScrollIfNeeded() {
      if (this.scrollX <= -this.$refs.track.scrollWidth / 2) {
        this.scrollX = 0; // Reset for infinite scroll effect
      }
    },
    handleWheel(event) {
      event.preventDefault();
      this.scrollX += event.deltaY * 0.5; // Adjust for smooth user scroll
      this.resetScrollIfNeeded();
    },
    handleTouchStart(event) {
      this.isTouching = true;
      this.touchStartX = event.touches[0].clientX;
    },
    handleTouchMove(event) {
      let touchMoveX = event.touches[0].clientX;
      this.scrollX += (touchMoveX - this.touchStartX) * 1.2; // Adjust sensitivity
      this.touchStartX = touchMoveX;
      this.resetScrollIfNeeded();
    },
    handleTouchEnd() {
      this.isTouching = false;
    },
  },
  
  
  
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Great+Vibes&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans:ital,wght@0,100..900;1,100..900&family=Noto+Serif:ital,wght@0,100..900;1,100..900&display=swap');

@import url('https://fonts.googleapis.com/css2?family=Great+Vibes&family=Kalam:wght@300;400;700&family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&family=Lexend:wght@100..900&family=Yellowtail&display=swap');
#app {
  font-family: "Noto Serif", serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
 margin-left: -8px;
 margin-top: -8px;
}

form {
  display: flex;
  flex-direction: column;       /* Stack items vertically */
  justify-content: center;      /* Vertical alignment (if needed) */
  align-items: center;          /* 🔹 Center items horizontally */
  margin: 0 auto;               /* 🔹 Center the form itself */
  padding: 1rem;
}

h1 {
  font-family: "Great Vibes", serif;
  font-size: max(10vw, 4rem);
  line-height: 1rem;
}

h2 {
  font-size: 4rem;
  font-family: "Great Vibes", serif;
}

h3 {
  font-size: max(2.6vw, 1.4rem);
}

h4 {
  font-size: max(1.6vw, 1.3rem);
  word-break:normal;
}

p, li {
  font-size: max(1.0vw, 1.0rem);
  font-family: "Noto Serif", serif;
  font-weight: 400;
  justify-items: left;
  justify-content: left;
  text-align: left;
  line-height: 1.6rem;
}

.email {
  word-break: break-all;
}

.logo {
  width: 60px;
}

.spacer {
  background: #f55fad7e;
  padding: 1px;
  margin: max(min(10vh,10vw), 60px);
  margin-bottom: min(14vh,14vw);
}

.header {
  position: sticky;
  top: 0;
  width: 100%;
  display: flex;
  justify-content: space-around;
  background-color: rgba(0,0,0,0); /* Default when at the top */
   color: white; 
  transition: background-color 0.8s ease-in-out;
  z-index: 1000; /* Ensures it stays above other content */
}


.scrolled {
  background-color: white !important;
  color: black;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.scrolled .cont {
  color:#f55fad
}


.banner {
  position: relative;
  width: 100%;
  height: max(50vw, 700px);
  overflow: hidden;
  margin-top: -63px;
}

.bannerIMG {
  width: 100%;
  height: auto;
  min-width: 1300px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  transition: transform 0.1s ease-out;
}


.CTA {
  padding: 2rem;
  font-size: max(2.5vw, 1rem);
  font-family: "Lato", serif;
}

.contactSub {
  margin-left: 5rem;
  max-width: 60vw;
}

.headerStuff {
  color: white;
  position: absolute;
  top: 50%; /* Position at the vertical center */
  left: max(25%,6rem); /* Position at the horizontal center */
  transform: translate(-50%, -50%); /* Center the element */
  text-align: center; /* Center the text */
  z-index: 1; /* Ensure the text appears above the image */
}


button {
  background-color: #f55fad; /* Bright pink */
  color: white; /* White text */
  font-size: 1.5rem; /* Big text */
  font-family: "Great Vibes", serif;
  padding: 15px 30px; /* Bigger button size */
  border: none; /* Remove border */
  border-radius: 10px; /* Rounded corners */
  cursor: pointer; /* Pointer cursor for interaction */
  text-transform: uppercase; /* Optional: make text uppercase */
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); /* Optional: subtle shadow */
  transition: background-color 0.3s ease, transform 0.2s ease; /* Smooth hover effect */
}

/* Optional hover effect */
button:hover {
  background-color: #ff85c4; /* Slightly lighter pink */
  transform: scale(1.05); /* Slight zoom-in */
}

/* Optional active state */
button:active {
  background-color: #ff4998; /* Darker pink */
  transform: scale(0.98); /* Slight press effect */
}

.titleblock {
  display: flex;
  justify-content: space-around;
  right: 5rem;
}

.menublock {
  display: flex;
  align-items: center;
  position: relative;
}

.title {
  font-size: 18px;
  cursor: pointer;
  font-family: "Great Vibes", serif;
}

.contactInfo {
  font-size: 32px;
  padding: 1rem;
  background-color: #f8c7dc;
  margin: 4rem;
  margin-bottom: 8rem;
  border-radius: 16px;
}

.contactInfo p {
  font-size: 32px;
}

.contactPhoto {
  width: calc(100vw - 25px)
}

.menuItems {
  display: flex;
  gap: 20px;
}

.menuItem {
  cursor: pointer;
  font-size: 18px;
  font-family: "Great Vibes", serif;
}

/* Hamburger Menu */
.menuToggle {
  display: none; /* Hide the checkbox */
}

.hamburger {
  display: none;
  flex-direction: column;
  justify-content: space-between;
  width: 30px;
  height: 24px;
  cursor: pointer;
  position: relative;
}

.hamburger span {
  display: block;
  width: 100%;
  height: 4px;
  background-color: #5e5e5e;
  border-radius: 2px;
}

.main {
  background-color: #fff3f9;
}

.Portfolio {
  padding: 20px;
  max-width: max(75vw, 1700px);
  margin: auto;
  margin-top: min(10vw,10vh);
}

.work {
  margin-bottom: 20px;
}

.columns {
  display: flex;
  gap: 10px; /* Gap between columns */
}

.column {
  flex: 1; /* Each column takes up equal space */
  display: flex;
  flex-direction: column;
  gap: 10px; /* Gap between photos within a column */
}

.photo {
  width: 100%; /* Photos take up full width of their container */
  height: auto; /* Maintain aspect ratio */
  border-radius: 4px;
}

.scrolling-gallery {
  width: calc(100vw - 25px);
  overflow: hidden;
  white-space: nowrap;
  display: flex;
  align-items: center;
  background-color: #fff3f9;
  padding: 20px 0;
  position: relative;
}

.gallery-track {
  display: flex;
  gap: 20px;
  will-change: transform;
  transition: transform 0.01s linear;
}

.gallery-image {
  height: 300px;
  width: auto;
  flex-shrink: 0;
  object-fit: cover;
  user-select: none;
  pointer-events: none;
}

.About {
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: max(75vw, 1700px);
  gap: 20px;
  margin: auto;
  padding: 20px;
  text-align: center;
}

.aboutPhoto {
  width: 60vw;
  height: auto;
  border-radius: 10px; /* Optional: Adds rounded corners to the image */
}

.aboutText {
  max-width: 100%;
}

/* For screens wider than 600px */
@media (min-width: 800px) {
  .About {
    flex-direction: row;
    align-items: flex-start;
    text-align: left;
  }

  .aboutPhoto {
    width: max(300px,30vw); /* Adjust the width of the image as needed */
    order: 2; /* Moves the image to the right */
    margin-left: 20px; /* Adds spacing between the text and image */
  }

  .aboutText {
    max-width: 60%; /* Adjust the width of the text container as needed */
    order: 1; /* Ensures the text stays on the left */
  }
}


/* Animation for auto-scrolling */
@keyframes scroll-left {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-50%);
  }
}


/* Responsive: Switch to 2 columns below 1000px */
@media (max-width: 900px) {
  .columns {
    flex-wrap: wrap; /* Allow wrapping for columns */
    gap: 10px; /* Maintain gap */
  }
  .column {
    flex: 0 0 calc(98%); /* Each column takes up 50% minus the gap */
  }
}

/* Responsive: Collapse to 1 column below 500px */
@media (max-width: 600px) {
  .column {
    flex: 0 0 calc(98%); /* Each column takes up 50% minus the gap */
  }

  .gallery-image {
    height: 200px;
  }

  .menuItems {
    display: none; /* Hide menu items by default */
    flex-direction: column;
    position: fixed;
    top: 0;
    right: 0;
    color: black;
    background-color: #fff3f9;
    z-index: 10;
    height: 100vh;
    width: 100vw;
  }

  .menuToggle:checked + .hamburger + .menuItems {
    display: flex; /* Show menu items when checkbox is checked */
  }

  .menuToggle:checked + .hamburger span {
    background-color: #434343;
  }

  .hamburger {
    display: flex; /* Show hamburger icon */
    z-index: 11;
  }

  .menuItem {
    font-size: 20px;
    padding: 0px 0;
    text-align: left;
    padding: 20px;
    padding-left: 30px;
    margin: 0px;
    background-color: #fff3f9;
  }

  .menuItem:hover {
    background-color: #ffe5f2;
  }
}
</style>
